document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.google-map__status-wrapper');
    if (!wrapper) return;

    const timezone = wrapper.dataset.timezone || 'America/Chicago';

    // Helper to convert "10 AM" or "7 PM" to 24h format HH:MM
    function convertTo24Hour(timeStr) {
        const parts = timeStr.match(/(\d+)(:\d{2})?\s*(AM|PM)/i);
        if (!parts) return null;

        let hours = parseInt(parts[1], 10);
        let minutes = parts[2] ? parts[2].substring(1) : '00';
        const modifier = parts[3].toUpperCase();

        if (hours === 12) {
            hours = (modifier === 'AM') ? 0 : 12;
        } else if (modifier === 'PM') {
            hours += 12;
        }
        return `${String(hours).padStart(2, '0')}:${minutes}`;
    }

    // Helper to parse "Monday - Friday: 10 AM - 7 PM" -> { open: "10:00", close: "19:00" }
    function parseHours(fullString) {
        if (!fullString) return null;
        // 1. Remove the Day part (everything before the first colon)
        const timePart = fullString.split(':').slice(1).join(':').trim(); // "10 AM - 7 PM"
        if (!timePart) return null;

        if (timePart.toLowerCase().includes('close')) return null;

        // 2. Split into Open and Close times
        const times = timePart.split('-').map(t => t.trim()); // ["10 AM", "7 PM"]
        if (times.length !== 2) return null;

        const openTime24 = convertTo24Hour(times[0]);
        const closeTime24 = convertTo24Hour(times[1]);

        if (!openTime24 || !closeTime24) return null;

        return {
            open: openTime24,
            close: closeTime24
        };
    }

    // Helper to get current time in target timezone
    function getTargetTime(tz) {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hour12: false,
            hour: 'numeric',
            minute: 'numeric',
            weekday: 'long'
        });

        const parts = formatter.formatToParts(now);
        const partMap = {};
        parts.forEach(p => partMap[p.type] = p.value);

        return {
            day: partMap.weekday.toLowerCase(),
            time: `${partMap.hour}:${partMap.minute}` // "14:30"
        };
    }

    function isStoreOpen() {
        try {
            const target = getTargetTime(timezone);
            const daySchedule = wrapper.dataset[target.day]; // e.g., dataset.monday

            if (!daySchedule) return false;

            const hours = parseHours(daySchedule);
            if (!hours) return false;

            // Compare strings directly "09:00" <= "14:30" <= "17:00"
            // Pad current time if needed (e.g. 9:30 -> 09:30)
            let [cHour, cMin] = target.time.split(':');
            cHour = cHour.padStart(2, '0');
            const currentTime = `${cHour}:${cMin}`; // Ensure "HH:MM" format

            return currentTime >= hours.open && currentTime < hours.close;

        } catch (e) {
            console.error("Error calculating open status:", e);
            return false;
        }
    }

    const indicator = wrapper.querySelector('.status-indicator');
    const text = wrapper.querySelector('.status-text');

    if (isStoreOpen()) {
        wrapper.classList.add('is-open');
        text.textContent = 'Open Now';
    } else {
        wrapper.classList.remove('is-open');
        text.textContent = 'Closed';
    }
});
